:host {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(var(--size-12), var(--size-96)));
  gap: var(--size-4);
  padding: var(--size-2);
  justify-content: center;
  align-items: start;
  justify-items: stretch;
}
